(() => {
  const positions = [
    ['.n-listicle-timeline__cta', 'timeline'],
    ['.n-listicle-closing__badge', 'badge'],
    ['.n-listicle-closing-sticky .n-listicle-closing__cta', 'sticky'],
    ['.n-listicle-closing__cta', 'closing'],
  ];
  const track = event => {
    if (event.type === 'auxclick' && event.button !== 1) return;
    const position = positions.find(([selector]) => event.target.closest(selector))?.[1];
    if (!position) return;
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true && typeof window.clarity === 'function') {
        window.clarity('event', `natunora_listicle_five_${position}_offer_click`);
      }
    } catch (_) {}
  };
  for (const type of ['click', 'auxclick']) document.addEventListener(type, track, { capture: true });
})();
